import * as React from "react";
const SVGComponent = ({
  width = 32,
  height = 32,
  color = "white",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.4832 2.66675C12.9413 2.91362 13.323 3.28429 13.679 3.66144C14.1149 4.12928 14.1099 4.46324 13.6419 4.91884C12.4925 6.1712 11.0991 7.65892 9.92764 8.88249C8.75044 10.1241 7.53187 11.3757 6.33326 12.5993C5.89663 13.034 5.48853 13.6105 4.82716 13.1844C4.38696 12.8829 3.83617 12.2603 3.44948 11.8925C2.95078 11.3743 2.29368 10.7538 1.81282 10.2234C1.36833 9.7757 1.16072 9.18767 1.51102 8.60827C1.86561 8.05694 2.54197 7.38254 3.23758 7.39621C3.94248 7.41637 4.45973 8.02167 4.93346 8.45352C5.04904 8.54637 5.19174 8.68888 5.34085 8.66945C5.51564 8.62626 5.67617 8.42185 5.81315 8.30166C7.64459 6.54547 9.59945 4.70507 11.493 3.02158C9.81563 4.92172 7.98134 6.88231 6.23266 8.71911C6.06643 8.89113 5.89663 9.0941 5.67474 9.20926C5.06688 9.53242 4.53678 8.99405 4.11799 8.61619C3.82048 8.38011 3.4823 8.02959 3.08276 8.14331C2.72532 8.27287 2.3686 8.67233 2.16455 8.9883C1.99403 9.25316 2.17026 9.47916 2.3743 9.68933C2.84661 10.1953 3.50941 10.8287 4.00241 11.3304C4.32203 11.637 4.89636 12.2732 5.24453 12.5237C5.28876 12.5546 5.3173 12.5554 5.28092 12.5518C5.26807 12.5518 5.25737 12.5561 5.25951 12.5561C5.30945 12.5374 5.3965 12.446 5.44358 12.4071C7.27145 10.5919 9.13072 8.78461 10.9971 7.01043C11.4787 6.55339 12.78 5.32766 13.2566 4.89005C13.4956 4.64677 13.8288 4.4474 13.7703 4.18326C13.6983 3.88744 13.4229 3.61322 13.2281 3.37354C13.0026 3.11587 12.7665 2.86396 12.484 2.66747L12.4832 2.66675Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
